import React from 'react';
import styled from 'styled-components';
import SvgIcon from '../../SvgIcon';

export const IconH = styled(SvgIcon).attrs({
  children: ({ color }: { color: string }) => (
    <path
      d="M2 13h2v2H2v-2Zm6 0H6v2h2v-2Zm4 0h-2v2h2v-2ZM2 16h2v9H2v-9Zm6 0H6v9h2v-9Zm4 0h-2v9h2v-9Z"
      fillRule="evenodd"
      transform="rotate(-90 2 13)"
      fill={color}
    />
  ),
})``;
